/**
 * Iter 66.15 — Authoritative AMC / Software fee resolution.
 *
 * Explicit model (Iter 66.15+):
 *   - `amount`     = Software & Set-up fee
 *   - `amc_amount` = AMC fee
 *   Both can be set on any line, regardless of `product_type`.
 *
 * Legacy compatibility:
 *   Pre-Iter-66.15 AMC-type lines stored AMC in `amount` and left
 *   `amc_amount` empty/0. Detect this case and route `amount` into the
 *   AMC column so existing proposals keep rendering correctly.
 *
 * Single source of truth — used by BOTH:
 *   • ProposalDetail.jsx (in-app line table + Year-1 Outflow strip)
 *   • ProposalPrint.jsx  (client-facing PDF / print preview)
 * …so screen and PDF values never diverge again.
 */

export const resolveSoftwareFee = (li) => {
  const amount = Number(li?.amount) || 0;
  const amcExplicit = Number(li?.amc_amount) || 0;
  // Legacy AMC-type line with no explicit AMC fee — amount IS the AMC.
  if (li?.product_type === "AMC" && amcExplicit === 0) return 0;
  return amount;
};

export const resolveAmcFee = (li) => {
  const amcExplicit = Number(li?.amc_amount) || 0;
  if (amcExplicit > 0) return amcExplicit;
  // Legacy AMC-type fallback — `amount` carried the AMC fee in the old model.
  if (li?.product_type === "AMC") return Number(li?.amount) || 0;
  return 0;
};

// Annual Cost (data/content, hosting, server management …) — optional third
// charge, mutually exclusive with AMC per item. Complimentary = explicit ₹0;
// an absent/blank amount is NOT complimentary.
export const isAnnualCostComplimentary = (li) => li?.annual_cost_pricing_mode === "complimentary";

export const resolveAnnualCostFee = (li) =>
  isAnnualCostComplimentary(li) ? 0 : Number(li?.annual_cost_amount) || 0;

export const usesAnnualCost = (li) => resolveAnnualCostFee(li) > 0 || isAnnualCostComplimentary(li);
